import type {
  ListResponsePriceOverrideApprovals,
  PriceOverrideApproveRejectInput,
} from "@classes-service-types/index";
import { type UseMutationOptions, useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";

type UsePriceOverridesApproveArgs = {
  payload: PriceOverrideApproveRejectInput;
};

export const usePriceOverridesApprove = (
  useMutationOptions?: UseMutationOptions<ListResponsePriceOverrideApprovals, Error, UsePriceOverridesApproveArgs>,
) => {
  // const queryClient = useQueryClient();

  return useMutation<ListResponsePriceOverrideApprovals, Error, UsePriceOverridesApproveArgs>({
    mutationFn: async (priceOverrideApproveArgs) => {
      const response: AxiosResponse<ListResponsePriceOverrideApprovals> = await learningServiceRequest({
        method: "put",
        url: "/price_overrides/approve/",
        payload: priceOverrideApproveArgs.payload,
      });
      return response.data;
    },
    ...useMutationOptions,
  });
};
